module.exports = __webpack_public_path__ + "img/card-icon-jcb.3b37bc70.svg";